import { initASwap } from './aswap'
import { TimelineMax, TweenMax, Elastic, Expo, Sine, Back } from 'gsap'


const startAnimationComplete = () => {
  initASwap()
  setTimeout(() => {
    document.documentElement.classList.remove('index-loading')
  }, 500)
  
}

const letterShow = (el, index) => {
  const delay = index * .05 + .2
  const wW = window.innerWidth
  const wH = window.innerHeight
  TweenMax.from(el, 1, {x: wW, ease: Expo.easeOut, delay})
}
const letterHide = (el, index) => {
  const delay = index * .025
  const wW = window.innerWidth
  const wH = window.innerHeight
  TweenMax.to(el, 1, {x: -wW, ease: Expo.easeIn, delay})
}

const loadingSequenceStart = (el) => {
  const wW = window.innerWidth
  const wH = window.innerHeight
  const list = [...el.querySelectorAll('.letter-wrap')]
  list.forEach(letterShow)
  const bg = el.querySelector('#loader-bg')
  let t1 = new TimelineMax({repeat: 0})
  t1.to(bg, 1, {opacity: 1, delay: 1, onComplete: () => {
    list.forEach(letterHide)
  }})
  t1.to(bg, .2, {backgroundColor: "#242F3E", delay: 1.3, onComplete: () => {
    
  }})
  t1.to(bg, .7, {y: -wH, ease: Expo.easeIn, delay: .1, onComplete: () => {
    startAnimationComplete()
  }})
  el.classList.add("animating")
}

export const startAnimation = () => {
  // to temporary disable loading just remove BOX index.php!
  const loading = document.querySelector('#page-loader')
  if (loading) {
    loadingSequenceStart(loading)
  } else {
    startAnimationComplete()
  }
}